/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EmailKeyOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Email Key Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M25.947 30H2v-2.392l11.165-8.358 3.635 2.725a2 2 0 0 0 2.4 0l3.088-2.325a7.977 7.977 0 0 1-.3-2.043c0-.087.022-.169.025-.255L18 20.375 2 8.38V6h32v2.334L31.959 9.87a7.94 7.94 0 0 1 3.7 2.075c.127.127.221.277.338.411V5.167A1.147 1.147 0 0 0 34.875 4H1.125A1.147 1.147 0 0 0 0 5.167v25.666A1.147 1.147 0 0 0 1.125 32h24.822ZM2 10.881 11.5 18 2 25.107Z"
    />
    <path
      d="M35.445 35.533v-2.887h-3.763v-1.084h3.763v-2.237a.467.467 0 0 0-.467-.467h-3.3v-5.927a5.546 5.546 0 0 0 2.283-1.359 5.607 5.607 0 1 0-7.93 0 5.542 5.542 0 0 0 2.313 1.367v12.126a.935.935 0 0 0 .935.935h5.695a.467.467 0 0 0 .471-.467Zm-4.123-17.462a1.869 1.869 0 1 1 0-2.643 1.869 1.869 0 0 1 0 2.643Z"
    />
  </svg>`;
};
